import request from '@/utils/request'

// 接口一：按小区汇总
export function queryReportCommunityFeeSummary(params) {
  return request({
    url: '/reportFeeMonthStatistics.queryReportCommunityFeeSummary',
    method: 'get',
    params
  })
}

// 接口二：按小区+费用类型+月份多维度汇总
export function queryReportCommunityFeeSummaryDetail(params) {
  return request({
    url: '/reportFeeMonthStatistics.queryReportCommunityFeeSummaryDetail',
    method: 'get',
    params
  })
}
